import organizations from '@/apis/coreIAM/organizations'
import { organizationsTypes } from '@/store/mutationTypes'

export default {
    state: {
        all: null,
        current: null,
        fetchAll: {
            pending: false,
            error: null
        },
        fetchOne: {
            pending: false,
            error: null,
        },
        createOne: {
            pending: false,
            error: null,
        },
        updateOne: {
            pending: false,
            error: null,
        },
        deleteOne: {
            pending: false,
            error: null,
        },
    },
    mutations: {
        [organizationsTypes.FETCH_ALL_REQUEST]: function (state) {
            state.fetchAll.pending = true;
        },
        [organizationsTypes.FETCH_ALL_SUCCESS]: function (state, organizations) {
            state.fetchAll.error = null;
            state.all = organizations;
            state.fetchAll.pending = false;
        },
        [organizationsTypes.FETCH_ALL_FAILURE]: function (state, error) {
            state.all = null;
            state.fetchAll.error = error;
            state.fetchAll.pending = false;
        },
        [organizationsTypes.SET_CURRENT_ORGANIZATION]: function (state, organization) {
            state.current = organization;
        },
        [organizationsTypes.FETCH_ONE_REQUEST]: function (state) {
            state.fetchOne.pending = true;
        },
        [organizationsTypes.FETCH_ONE_SUCCESS]: function (state) {
            state.fetchOne.error = null;
            state.fetchOne.pending = false;
        },
        [organizationsTypes.FETCH_ONE_FAILURE]: function (state, error) {
            state.fetchOne.error = error;
            state.fetchOne.pending = false;
        },
        [organizationsTypes.CREATE_ONE_REQUEST]: function (state) {
            state.createOne.pending = true;
        },
        [organizationsTypes.CREATE_ONE_SUCCESS]: function (state) {
            state.createOne.error = null;
            state.createOne.pending = false;
        },
        [organizationsTypes.CREATE_ONE_FAILURE]: function (state, error) {
            state.createOne.error = error;
            state.createOne.pending = false;
        },
        [organizationsTypes.UPDATE_ONE_REQUEST]: function (state) {
            state.updateOne.pending = true;
        },
        [organizationsTypes.UPDATE_ONE_SUCCESS]: function (state) {
            state.updateOne.error = null;
            state.updateOne.pending = false;
        },
        [organizationsTypes.UPDATE_ONE_FAILURE]: function (state, error) {
            state.updateOne.error = error;
            state.updateOne.pending = false;
        },
        [organizationsTypes.DELETE_ONE_REQUEST]: function (state) {
            state.deleteOne.pending = true;
        },
        [organizationsTypes.DELETE_ONE_SUCCESS]: function (state) {
            state.deleteOne.error = null;
            state.deleteOne.pending = false;
        },
        [organizationsTypes.DELETE_ONE_FAILURE]: function (state, error) {
            state.deleteOne.error = error;
            state.deleteOne.pending = false;
        },
    },
    actions: {
        async fetchAll({ commit }) {
            commit(organizationsTypes.FETCH_ALL_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .fetchAll()
                    .then((organizations) => {
                        commit(organizationsTypes.FETCH_ALL_SUCCESS, organizations.data);
                        resolve(organizations.data);
                    })
                    .catch((error) => {
                        commit(organizationsTypes.FETCH_ALL_FAILURE, error);
                        reject(error);
                    })
            })
        },
        setCurrentOrganization({ commit }, payload) {
            commit(organizationsTypes.SET_CURRENT_ORGANIZATION, payload.organization)
        },
        async fetchOne({ commit }, payload) {
            commit(organizationsTypes.FETCH_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .fetchOne(payload.organizationUuid)
                    .then((organization) => {
                        commit(organizationsTypes.FETCH_ONE_SUCCESS)
                        resolve(organization.data)
                    })
                    .catch((error) => {
                        commit(organizationsTypes.FETCH_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async createOne({ commit }, payload) {
            commit(organizationsTypes.CREATE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .createOrganization(payload.name)
                    .then((organization) => {
                        commit(organizationsTypes.CREATE_ONE_SUCCESS)
                        resolve(organization.data)
                    })
                    .catch((error) => {
                        commit(organizationsTypes.CREATE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async updateOne({ commit }, payload) {
            commit(organizationsTypes.UPDATE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .updateOrganization(payload.organizationUuid, payload.name)
                    .then((organization) => {
                        commit(organizationsTypes.UPDATE_ONE_SUCCESS)
                        resolve(organization.data)
                    })
                    .catch((error) => {
                        commit(organizationsTypes.UPDATE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async deleteOne({ commit }, payload) {
            commit(organizationsTypes.DELETE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .deleteOrganization(payload.organizationUuid)
                    .then(() => {
                        commit(organizationsTypes.DELETE_ONE_SUCCESS)
                        resolve()
                    })
                    .catch((error) => {
                        commit(organizationsTypes.DELETE_ONE_FAILURE)
                        reject(error)
                    })
            })
        },
    },
}